

















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class Question extends Vue {
  @Prop(String) private readonly uuid: string | undefined;
  @Prop(String) private readonly image: string | undefined;
  @Prop(Number) private readonly timeout!: number;
  @Prop(Boolean) private readonly disabled!: boolean;

  private displayImg = true;

  private created() {
    this.uuidChanged();
  }

  @Watch('uuid')
  private uuidChanged() {
    this.displayImg = true;
    setTimeout(() => {
      this.displayImg = false;
    }, this.timeout * 1000);
  }

  private get imgUrl() {
    if (this.image!.startsWith('http')) {
      return this.image;
    } else {
      return `${process.env.VUE_APP_IMG_PATH}/${this.image}`;
    }
  }
}
